import React from 'react';
import styled, { css } from 'styled-components';
import { ContentfulContentCard } from '../contentCard/ContentCard';
import { ContentfulImageAsset } from '../../../interfaces/ContentfulImageAsset';
import {
  ContentfulHeading,
  ContentfulHeadingProps,
} from '../../contentfulHeading';
import { breakpoint, theme } from '../../../theme';

export type ContentCardContainerProps = {
  heading: ContentfulHeadingProps;
  cardPanelsCollection: {
    items: {
      title: string;
      description: string;
      image: ContentfulImageAsset;
      urlLink: string;
      openInNewTab: boolean;
      button?: string;
      altText: string;
    }[];
  };
  setAFeaturedCard?: boolean;
};

const ContentCardContainerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[5].rem};
`;

const Container = styled.div<{
  hasFeaturedCard?: boolean;
  cardCount?: number;
}>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${theme.spacings[5].rem};
  ${breakpoint('sm')`
      flex-direction: row;
    `}
  ${breakpoint('lg')`
      flex-wrap: nowrap;
    `}
  ${({ hasFeaturedCard, cardCount }) =>
    hasFeaturedCard &&
    cardCount === 4 &&
    css`
      ${breakpoint('lg')`
        flex-wrap: wrap;
        & > :nth-child(1) {
          flex-basis: 100%;
        }
        & > :nth-child(n+2) {
          flex-grow: 1;
          flex-basis: 0;
        }
      `}
    `}
`;

export const ContentCardContainer: React.FC<ContentCardContainerProps> = (
  data
) => {
  const cardCount = data?.cardPanelsCollection?.items.length || 0;
  const hasFeaturedCard = data?.setAFeaturedCard;
  return (
    <ContentCardContainerWrapper>
      {data.heading && (
        <ContentfulHeading
          heading={data?.heading?.heading}
          subHeading={data?.heading?.subHeading}
        />
      )}

      <Container hasFeaturedCard={hasFeaturedCard} cardCount={cardCount}>
        {hasFeaturedCard && cardCount === 4 && (
          <ContentfulContentCard
            hasFeaturedCard={hasFeaturedCard}
            title={data.cardPanelsCollection.items[0].title}
            description={data.cardPanelsCollection.items[0].description}
            image={data.cardPanelsCollection.items[0].image}
            urlLink={data.cardPanelsCollection.items[0].urlLink}
            openInNewTab={data.cardPanelsCollection.items[0].openInNewTab}
            button={data.cardPanelsCollection.items[0].button}
            altText={data.cardPanelsCollection.items[0].altText}
          />
        )}
        {data?.cardPanelsCollection?.items
          .slice(hasFeaturedCard && cardCount === 4 ? 1 : 0)
          .map((card) => (
            <ContentfulContentCard
              title={card.title}
              description={card.description}
              image={card.image}
              urlLink={card.urlLink}
              openInNewTab={card.openInNewTab}
              button={card.button}
              altText={card.altText}
            />
          ))}
      </Container>
    </ContentCardContainerWrapper>
  );
};
